import { Box } from '@material-ui/core';
import { ProductMatchButton } from '../../../button/index';
import { SearchFormOptions } from '../../../../enums';

interface OptionsProps {
  options: SearchFormOptions[];
  expanded?: boolean;
  currentOption: SearchFormOptions;
  mobileView?: boolean;
  onClick: (option: SearchFormOptions) => void;
}

export const Options = ({
  options,
  expanded,
  currentOption,
  mobileView,
  onClick
}: OptionsProps) => (
  <Box display="flex" gridGap="12px" flexWrap="wrap">
    {options.map(option => (
      <ProductMatchButton
        expanded={expanded}
        mobileView={mobileView}
        key={option}
        type={option}
        active={currentOption === option}
        onClick={onClick}
      />
    ))}
  </Box>
);
